import { Tag } from 'antd';
import styled from 'styled-components';

export const MpTag = styled(Tag)`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0;
	padding: 2px 7px;
	height: 24px;
	border-radius: 24px;
	font-weight: 600;
	font-size: 12px;
`;
